module.exports = __webpack_public_path__ + "static/media/photo_008.a579712b.JPG";